import { createEffect, createEvent, sample } from 'effector';
import { debounce } from 'patronum';
import { cache, createQuery, localStorageCache } from '@farfetched/core';
import { signout } from '@features/common';
import * as api from './api';
import type { SearchPeoplePayload, SearchPeopleResponse } from './types';

export const searchPeople = createEvent<string>();
export const resetData = createEvent<void>();

const fxSearchPeople = createEffect<
  SearchPeoplePayload,
  SearchPeopleResponse,
  Error
>().use(api.searchPeople);

export const searchPeopleQuery = createQuery({
  effect: fxSearchPeople,
  name: 'search-people',
  mapData: ({ result }) =>
    Array.isArray(result?.list)
      ? result.list.map((item) => ({
          id: item?.id,
          label: item?.title,
        }))
      : [],
});

searchPeopleQuery.$data.reset([signout, resetData]);

cache(searchPeopleQuery, {
  adapter: localStorageCache({ maxAge: '5m' }),
  purge: signout,
});

/** Запрос данных */
sample({
  clock: debounce({
    source: searchPeople,
    timeout: 1000,
  }),
  fn: (value) => ({
    q: value,
  }),
  target: searchPeopleQuery.start,
});
